import { HTTPResponseType } from "../interface/type/http-response-type.type";
import { HTTPMethod } from "./http-method.enum";

    /**
     * @description
     *  Un request HTTP. Contiene toda la información necesaria para consultar
     *  un endpoint en algún servidor usando un cliente HTTP.
     */

export class HTTPRequest<T> {

    public controllerPath: string;
    public host : string;
    public method: HTTPMethod;
    public payload: T;
    public relativePath: string;
    public responseType: HTTPResponseType;

    public constructor(builder: HTTPRequestBuilder<T>) {
        this.controllerPath = builder._controllerPath;
        this.host = builder._host;
        this.method = builder._method;
        this.payload = builder._payload;
        this.relativePath = builder._relativePath;
        this.responseType = builder._responseType;
    }
}

    /**
     * @description
     *  Patrón builder para construir un request HTTP.
     */

export class HTTPRequestBuilder<T> {

    public _controllerPath: string;
    public _host : string;
    public _method: HTTPMethod;
    public _payload: T;
    public _relativePath: string;
    public _responseType: HTTPResponseType;

    constructor() {
        this._controllerPath = "";
        this._host = undefined;
        this._method = undefined;
        this._payload = undefined;
        this._relativePath = "";
        this._responseType = "json";
    }

    public build(): HTTPRequest<T> {
        return new HTTPRequest<T>(this);
    }

    public controllerPath(controllerPath: string): HTTPRequestBuilder<T> {
        this._controllerPath = controllerPath;
        return this;
    }

    public host(host : string) : HTTPRequestBuilder<T> {
        this._host = host;
        return this
    }

    public method(method: HTTPMethod): HTTPRequestBuilder<T> {
        this._method = method;
        return this;
    }

    public payload(payload: T): HTTPRequestBuilder<T> {
        this._payload = payload;
        return this;
    }

    public relativePath(relativePath: string): HTTPRequestBuilder<T> {
        this._relativePath = relativePath;
        return this;
    }

    public responseType(responseType: HTTPResponseType): HTTPRequestBuilder<T> {
        this._responseType = responseType;
        return this;
    }
}
